import type { PaymentRepository } from '../../domain/interfaces/PaymentRepository';
import type {
  PaymentCardFormatterFactory,
  PaymentSdkClient,
  PaymentSdkReadyResponse,
} from '../interfaces/PaymentSdkClient';
import type {
  PaymentContextFailureModel,
  PaymentContextResultParams,
  PaymentContextSuccessModel,
  PaymentContextVerifyModel,
  PaymentGateway,
  PaymentRequestModel,
  PaymentResult,
  PayOptions,
} from '../../domain/models/payment.types';
import {
  toPayViaLinkDetailsAppVm,
  type PayViaLinkDetailsAppVm,
} from '../viewModels/payment.app.vm';

export type PaymentService = ReturnType<typeof createPaymentService>;

export function createPaymentService(
  repository: PaymentRepository,
  gateway: PaymentGateway,
  sdkClient: PaymentSdkClient
) {
  return {
    async getPayViaLinkDetails(queryString: string): Promise<PayViaLinkDetailsAppVm> {
      const details = await repository.getPayViaLinkDetails(queryString);
      return toPayViaLinkDetailsAppVm(details);
    },
    async createPaymentRequest(txnId: string): Promise<PaymentRequestModel> {
      const res = await repository.createPaymentRequest(txnId);
      return res;
    },
    async verifyPaymentContext(txnId: string): Promise<PaymentContextVerifyModel> {
      const res = await repository.verifyPaymentContext(txnId);
      return res;
    },
    async getPaymentContextSuccess(params: PaymentContextResultParams): Promise<PaymentContextSuccessModel> {
      const res = await repository.getPaymentContextSuccess(params);
      return res;
    },
    async getPaymentContextFailure(params: PaymentContextResultParams): Promise<PaymentContextFailureModel> {
      const res = await repository.getPaymentContextFailure(params);
      return res;
    },
    async processPayment(options: PayOptions): Promise<PaymentResult> {
      const res = await gateway.pay(options);
      return res;
    },
    async loadPaymentSdk(): Promise<void> {
      await sdkClient.load();
    },
    async onPaymentSdkReady(
      key: string,
      handler: (response: PaymentSdkReadyResponse) => void
    ): Promise<void> {
      await sdkClient.onReady(key, handler);
    },
    getCardFormatter(): PaymentCardFormatterFactory | undefined {
      return sdkClient.getCardFormatter();
    }
  };
}
